import { create } from 'zustand';
import { HotelVisualizationState, VisualHotel } from './types';
import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../../lib/firebase/config';
import { AccommodationTable } from '../../types/accommodation';
import { transformAccommodationData } from './utils';

export const useHotelVisualizationStore = create<HotelVisualizationState>((set) => ({
  hotels: {},
  loading: false,
  error: null,

  fetchHotels: async () => {
    set({ loading: true, error: null });
    try {
      // Get all accommodation tables
      const querySnapshot = await getDocs(collection(firestore, 'AccommodationTables'));
      const tables: AccommodationTable[] = [];
      querySnapshot.forEach((doc) => {
        tables.push({ id: doc.id, ...doc.data() } as AccommodationTable);
      });

      // Transform data into visualization format
      const hotels = transformAccommodationData(tables);
      
      set({ hotels, loading: false });
    } catch (error: any) {
      console.error('Error fetching hotels:', error);
      set({ error: error.message, loading: false });
    }
  }
}));